import React, { useState, useEffect } from 'react';

const TagManager = ({ onTagsChange, selectedTags }) => {
  const [commonTags, setCommonTags] = useState([]);
  const [customTag, setCustomTag] = useState('');

  // 加载常用标签
  useEffect(() => {
    const savedTags = JSON.parse(localStorage.getItem('commonTags') || '[]');
    setCommonTags(savedTags);
  }, []);

  // 添加标签
  const handleAddTag = (tag) => {
    if (!selectedTags.includes(tag)) {
      onTagsChange([...selectedTags, tag]);
    }
  };

  // 移除标签
  const handleRemoveTag = (tagToRemove) => {
    onTagsChange(selectedTags.filter(tag => tag !== tagToRemove));
  };

  // 添加自定义标签
  const handleAddCustomTag = () => {
    if (customTag.trim() && !selectedTags.includes(customTag.trim())) {
      onTagsChange([...selectedTags, customTag.trim()]);
      setCustomTag('');
    }
  };

  // 默认常用标签
  const defaultTags = [
    '控油', '保湿', '祛痘', '美白', '抗衰老', '舒缓', '清洁', '去黑头',
    '细致毛孔', '修护', '防晒', '提亮', '补水', '平衡', '温和', '强效'
  ];

  const allTags = [...new Set([...commonTags, ...defaultTags])];

  return (
    <div>
      <label className="block text-sm font-medium text-gray-300 mb-4">
        核心功效标签
      </label>
      
      {/* 常用标签池 */}
      <div className="mb-3">
        <p className="text-xs text-gray-500 mb-2">常用标签（点击添加）:</p>
        <div className="flex flex-wrap gap-2">
          {allTags.map(tag => (
            <button
              key={tag}
              type="button"
              onClick={() => handleAddTag(tag)}
              disabled={selectedTags.includes(tag)}
              className={`px-3 py-1 text-xs rounded-full border transition-all ${
                selectedTags.includes(tag)
                  ? 'bg-gray-800 text-gray-100 border-gray-700'
                  : 'bg-gray-200 text-gray-700 border-gray-300 hover:bg-gray-300'
              }`}
            >
              {tag}
            </button>
          ))}
        </div>
      </div>

      {/* 自定义标签输入 */}
      <div className="mb-3">
        <p className="text-xs text-gray-500 mb-2">自定义标签:</p>
        <div className="flex space-x-2">
          <input
            type="text"
            value={customTag}
            onChange={(e) => setCustomTag(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleAddCustomTag()}
            placeholder="输入自定义标签"
            className="flex-1 px-3 py-2 rounded-lg text-sm"
            style={{ 
              backgroundColor: '#1F1F1F', 
              border: '1px solid #2A2A2A',
              color: '#FFFFFF'
            }}
          />
          <button
            type="button"
            onClick={handleAddCustomTag}
            className="px-4 py-2 rounded-lg text-sm"
            style={{ backgroundColor: '#4A4A4A', color: '#FFFFFF' }}
          >
            添加
          </button>
        </div>
      </div>

      {/* 已选标签 */}
      {selectedTags.length > 0 && (
        <div>
          <p className="text-xs text-gray-500 mb-2">已选标签:</p>
          <div className="flex flex-wrap gap-2">
            {selectedTags.map(tag => (
              <span
                key={tag}
                className="px-3 py-1 text-xs rounded-full bg-gray-800 text-gray-100 border border-gray-700 flex items-center"
              >
                {tag}
                <button
                  type="button"
                  onClick={() => handleRemoveTag(tag)}
                  className="ml-2 text-gray-400 hover:text-red-400"
                >
                  ×
                </button>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TagManager;
